<app-card-consulta 
  (update)="update.emit($event)" 
  [titulo]="titulo" 
  [idConsulta]='idConsulta' 
  [tipoConsulta]="tipoConsulta" 
  [codigoControle]="codigoControle"
  [status]="status"
  [msg]="statusMsg"
>
    
    <ng-container *ngIf="consulta">
        <ul class="card-list-striped py-1">
            <li>
                <span class="text-secondary">NACIONALIDADE:</span>
                <span class="text-uppercase">{{ consulta?.nacionalidade || msgNull }}</span>
            </li>
            <li>
                <span class="text-secondary">NATUREZA:</span>
                <span class="text-uppercase">{{ consulta?.natureza || msgNull }}</span>
            </li>
            <li>
                <span class="text-secondary">ORIGEM:</span>
                <span class="text-uppercase">{{ consulta?.origem || msgNull }}</span>
            </li>
            <li>
                <span class="text-secondary">AUTORIZADO:</span>
                <span class="text-uppercase">{{ consulta?.autorizado || msgNull }}</span>
            </li>
            <li>
                <span class="text-secondary">REALIZADO:</span>
                <span class="text-uppercase">{{ consulta?.realizado || msgNull }}</span>
            </li>
            <li>
                <span class="text-secondary">SOCIAL:</span>
                <span class="text-uppercase">{{ consulta?.social || msgNull }}</span>
            </li>
        </ul>
    </ng-container>

</app-card-consulta>